/* tslint:disable */
/* eslint-disable */

/**
 * 805290007 = Entwurf (Entwurf)
 * 
 * 1 = Erfasst (Erfasst)
 * 
 * 805290000 = InPrufung (In Prüfung)
 * 
 * 805290001 = Entscheidung (Entscheidung)
 * 
 * 805290002 = Durchfuhrung (Durchführung)
 * 
 * 805290003 = Abschluss (Abschluss)
 * 
 * 805290004 = Ablehnung (Ablehnung)
 * 
 * 645030001 = Zuruckziehenbeantragt (Zurückziehen beantragt)
 * 
 * 2 = Beendet (Beendet)
 * 
 * 805290005 = Abgelehnt (Abgelehnt)
 * 
 * 805290006 = Storniert (Storniert)
 * 
 * 401130001 = Zuruckgezogen (Zurückgezogen)
 */
import {EnumValue} from "@/core/models/enumvalue.model"
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export enum AceProjektAceProjektEnumsAceProjektStatuscode {
 Entwurf = 805290007,
 Erfasst = 1,
 InPrufung = 805290000,
 Entscheidung = 805290001,
 Durchfuhrung = 805290002,
 Abschluss = 805290003,
 Ablehnung = 805290004,
 Zuruckziehenbeantragt = 645030001,
 Beendet = 2,
 Abgelehnt = 805290005,
 Storniert = 805290006,
 Zuruckgezogen = 401130001
}

marker([
    "Enum.AceProjektAceProjektEnumsAceProjektStatuscode.Entwurf",
    "Enum.AceProjektAceProjektEnumsAceProjektStatuscode.Erfasst",
    "Enum.AceProjektAceProjektEnumsAceProjektStatuscode.InPrufung",
    "Enum.AceProjektAceProjektEnumsAceProjektStatuscode.Entscheidung",
    "Enum.AceProjektAceProjektEnumsAceProjektStatuscode.Durchfuhrung",
    "Enum.AceProjektAceProjektEnumsAceProjektStatuscode.Abschluss",
    "Enum.AceProjektAceProjektEnumsAceProjektStatuscode.Ablehnung",
    "Enum.AceProjektAceProjektEnumsAceProjektStatuscode.Zuruckziehenbeantragt",
    "Enum.AceProjektAceProjektEnumsAceProjektStatuscode.Beendet",
    "Enum.AceProjektAceProjektEnumsAceProjektStatuscode.Abgelehnt",
    "Enum.AceProjektAceProjektEnumsAceProjektStatuscode.Storniert",
    "Enum.AceProjektAceProjektEnumsAceProjektStatuscode.Zuruckgezogen"
]);

export namespace AceProjektAceProjektEnumsAceProjektStatuscode
{
    class DataSets
    {
        static AceProjektAceProjektEnumsAceProjektStatuscodeDataSet: Array<EnumValue> = new Array<EnumValue>(
            new EnumValue("Entwurf", 805290007, "Entwurf"),
            new EnumValue("Erfasst", 1, "Erfasst"),
            new EnumValue("InPrufung", 805290000, "In Prüfung"),
            new EnumValue("Entscheidung", 805290001, "Entscheidung"),
            new EnumValue("Durchfuhrung", 805290002, "Durchführung"),
            new EnumValue("Abschluss", 805290003, "Abschluss"),
            new EnumValue("Ablehnung", 805290004, "Ablehnung"),
            new EnumValue("Zuruckziehenbeantragt", 645030001, "Zurückziehen beantragt"),
            new EnumValue("Beendet", 2, "Beendet"),
            new EnumValue("Abgelehnt", 805290005, "Abgelehnt"),
            new EnumValue("Storniert", 805290006, "Storniert"),
            new EnumValue("Zuruckgezogen", 401130001, "Zurückgezogen"),
        )
    }

    export function getAsDataset() {
        return DataSets.AceProjektAceProjektEnumsAceProjektStatuscodeDataSet;
    }
}
